module.exports = __webpack_public_path__ + "img/bg1.76c18af3.png";